import type { PostAskInsightSchema } from "@msuite/utils/schemas";
import { motion } from "motion/react";

/** Props Interface */
interface InsightsSpotlightQuestionProps {
	item: PostAskInsightSchema;
}

export function InsightsSpotlightQuestion({ item }: InsightsSpotlightQuestionProps) {
	/** Render */
	return (
		<motion.div className="card w-2/3 self-end rounded-xl px-5 py-4 rounded-br-sm text-lg">
			<p>{item.question}</p>
		</motion.div>
	);
}
